import { useContext, useState } from 'react';
import * as Style from './style/ProfileStyle';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../context/UserContext';
import { toast, ToastContainer } from 'react-toastify';
import { allFuncionalities } from './utils/arrayFuncionalities';
import AttToken from '../../helpers/attToken';
import { trackEventMatomo } from '../../helpers/matomo';
import BounceCheckbox from '../CheckboxAccess/BounceCheckbox';
import AccessControl from '../../service/AccessControl';
import { Skeleton } from '@mui/material';
import QueryFn from '../../helpers/QueryFn';

const accessControlService = new AccessControl();
const queryFn = new QueryFn();

export default function Role() {
  const { hierarchyLabel } = useContext(UserContext);
  const { t, i18n } = useTranslation('translation');
  const [access, setAccess] = useState<string[]>([]);
  const [role, setRole] = useState('Usuario');

  const { data, isLoading: isLoadingFuncs, isFetching: isFetchingFuncs } = queryFn.useFetch('GET_FUNCIONALITIES_LIST',
    async () => {
      try {
        const token = await AttToken();
        if (token) {
          const responseAllFuncs = await accessControlService.getAllFunctionalities(token);
          getRoleAccess(role);
          if (Array.isArray(responseAllFuncs)) {
            return { all: responseAllFuncs };
          } else {
            return { all: [], role: [] };
          }
        }
      } catch (err) {
        console.error(err);
      }
    }
  );

  const { mutate, isPending: isLoadingChange } = queryFn.useMutate('UPDATE_USER_FUNCIONALITIES',
    async () => {
      await toast.promise(async () => {
        const token = await AttToken();
        if (token) {
          const result = await accessControlService.changeByRole(token, role, access);
          return result;
        }
      }, {
        pending: 'Alterando Permissões...',
        success: 'Permissões Alteradas!',
        error: 'falha'
      });
    });

  const { mutate: getRoleAccess, isPending: isLoading } = queryFn.useMutate('GET_ROLE_FUNCTION',
    async (selectedRole: string) => {
      try {
        const token = await AttToken();
        if (token) {
          const responseRoleFuncs = await accessControlService.getAllByRole(token, selectedRole);
          if (Array.isArray(responseRoleFuncs)) {
            setAccess(responseRoleFuncs);
            return responseRoleFuncs;
          } else {
            setAccess([]);
            return [];
          }
        }
      } catch (err) {
        console.error(err);
      }
    });

  const roles = {
    // Gestor: t('profiles.coordinator'),
    Gerente: t('profiles.manager'),
    Supervisor: 'Supervisor',
    Usuario: t('profiles.user'),
  };

  return isLoading || isLoadingFuncs || isFetchingFuncs ? (<Skeleton variant='rounded' height={400} width={'100%'} />) : (
    <Style.ProfileContainer >
      <ToastContainer />
      <label>{t('settingsPage.profile.select')}</label>
      <div className="select is-small" style={{ marginTop: "10px" }}>
        <select
          onClick={() => trackEventMatomo('gestão de perfil', 'click', 'select', 'seleciona valor')}
          style={{ width: "100%" }}
          onChange={(e) => {
            setRole(e.target.value);
            getRoleAccess(e.target.value);
          }} defaultValue={role}>
          {Object.keys(roles).map((e) => (
            <option key={e} value={e}>
              {roles[e as keyof typeof roles]}
            </option>
          ))}
        </select>
      </div>
      <h1>{t('settingsPage.profile.whichFunc')}</h1>
      <Style.OptionsWrapper>
        {data?.all.filter((e: any) => e !== 'home').map((key: any, index: any) => {
          const keyFind = allFuncionalities.find(func => func.key === key);
          const name = keyFind ? keyFind.name : '';
          return (
            <Style.StyledLabel checked={access.some((el: string) => el.toLowerCase() === key.toLowerCase())}>
              <BounceCheckbox
                id={`checkbox-circle-${index}`}
                checked={access.some((el: string) => el.toLowerCase() === key.toLowerCase())}
                onChange={() => {
                  trackEventMatomo('gestão de perfil', 'click', 'input', 'edita valor');
                  if (access.some((el: string) => el.toLowerCase() === key.toLowerCase())) {
                    setAccess(access.filter((el) => el !== key));
                  } else setAccess([...access, key]);
                }}
              />
              &nbsp;&nbsp;{
                key === 'locais' ? `${i18n.resolvedLanguage !== 'en' ? `${t(name)}`
                  : `${hierarchyLabel.local} ${t(name)}`}` :
                  key === 'gerencias' ? `${i18n.resolvedLanguage !== 'en' ? `${t(name)} ${hierarchyLabel.gerencia}`
                    : `${hierarchyLabel.gerencia} ${t(name)}`}` :
                    t(name)
              }
            </Style.StyledLabel>
          );
        })}
        <button
          className="button is-success"
          type="button" style={{ width: '50%', alignSelf: 'center', margin: '15px' }}
          disabled={isLoadingChange}
          onClick={() => {
            trackEventMatomo('gestão de perfil', 'click', 'button', 'salva');
            mutate('');
          }}
        >
          {`${t('settingsPage.profile.givePermissions')} ${role}.`}
        </button>
      </Style.OptionsWrapper>
    </Style.ProfileContainer >
  );
}